(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cutoff"] && !Shopify.designMode) return;
  try {
    (function () {
    const blocks = document.querySelectorAll('.acut');
    if (!blocks.length) return;

    const HEADLINE_BEFORE = {};
    const SUB_BEFORE      = {};
    const HEADLINE_AFTER  = {};
    const SUB_AFTER       = {};

    blocks.forEach((block) => {
      // Cache initial texts (Liquid-injected)
      const id = block.getAttribute('data-block-id') || Math.random().toString(36);
      block.setAttribute('data-block-id', id);
      const headlineEl = block.querySelector('[data-headline]');
      const subEl = block.querySelector('[data-sub]');
      HEADLINE_BEFORE[id] = headlineEl ? headlineEl.textContent : '';
      SUB_BEFORE[id] = subEl ? subEl.textContent : '';
      // After-cutoff texts pulled from data-attrs (set below via Liquid)
      HEADLINE_AFTER[id] = block.dataset.headlineAfter || HEADLINE_BEFORE[id];
      SUB_AFTER[id] = block.dataset.subAfter || SUB_BEFORE[id];
    });

    function nextCutoff(now, hour, minute, skipWeekend) {
      const cutoff = new Date(now);
      cutoff.setHours(hour, minute, 0, 0);

      // Wenn aktuelle Zeit >= Cutoff → next day
      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
      }
      // Wochenende skippen
      if (skipWeekend) {
        while (cutoff.getDay() === 0 || cutoff.getDay() === 6) {
          cutoff.setDate(cutoff.getDate() + 1);
        }
      }
      return cutoff;
    }

    function tick(block) {
      const hour = parseInt(block.dataset.cutoffHour || '14', 10);
      const minute = parseInt(block.dataset.cutoffMinute || '0', 10);
      const skipWeekend = block.dataset.skipWeekend === 'true';

      const now = new Date();
      const target = nextCutoff(now, hour, minute, skipWeekend);
      let diffSec = Math.max(0, Math.floor((target - now) / 1000));

      const days = Math.floor(diffSec / 86400);
      diffSec %= 86400;
      const hours = Math.floor(diffSec / 3600) + (days * 24);
      diffSec %= 3600;
      const mins = Math.floor(diffSec / 60);
      const secs = diffSec % 60;

      const hEl = block.querySelector('[data-hours]');
      const mEl = block.querySelector('[data-mins]');
      const sEl = block.querySelector('[data-secs]');
      if (hEl) hEl.textContent = String(hours).padStart(2, '0');
      if (mEl) mEl.textContent = String(mins).padStart(2, '0');
      if (sEl) sEl.textContent = String(secs).padStart(2, '0');
    }

    blocks.forEach(tick);
    setInterval(() => blocks.forEach(tick), 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["liveticker"] && !Shopify.designMode) return;
  try {
    (function () {
    const blocks = document.querySelectorAll('.aord:not([data-aord-init])');
    if (!blocks.length) return;

    function timeAgo(mins) {
      mins = Math.max(0, parseInt(mins, 10) || 0);
      if (mins < 1) return 'gerade eben';
      if (mins === 1) return 'vor 1 Min.';
      if (mins < 60) return 'vor ' + mins + ' Min.';
      const h = Math.floor(mins / 60);
      if (h === 1) return 'vor 1 Std.';
      if (h < 24) return 'vor ' + h + ' Std.';
      return 'heute';
    }

    function pickDemoData(block) {
      const node = block.querySelector('[data-aord-demo]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent || '[]');
      } catch (e) {
        return [];
      }
    }

    async function fetchLiveData(endpoint) {
      try {
        const res = await fetch(endpoint, { credentials: 'omit' });
        if (!res.ok) return [];
        const data = await res.json();
        // Expected shape: [{name:"Sarah", city:"Köln", mins:3}, ...]
        return Array.isArray(data) ? data : [];
      } catch (e) {
        return [];
      }
    }

    function renderItem(block, item) {
      const stream = block.querySelector('[data-stream]');
      if (!stream) return;
      const current = stream.querySelector('[data-current]');
      if (!current) return;

      // animate out, then update text, then animate in
      current.classList.add('aord-leaving');
      setTimeout(() => {
        const nameEl = current.querySelector('[data-name]');
        const metaEl = current.querySelector('[data-meta]');
        const timeEl = current.querySelector('[data-time]');
        const actionText = block.querySelector('[data-meta]')?.dataset?.action || '';
        if (nameEl) nameEl.textContent = item.name + (item.city ? ' aus ' + item.city : '');
        if (metaEl) metaEl.textContent = block.dataset.actionText || metaEl.textContent;
        if (timeEl) timeEl.textContent = timeAgo(item.mins);
        current.classList.remove('aord-leaving');
        current.classList.add('aord-entering');
        // force reflow then remove entering
        void current.offsetWidth;
        current.classList.remove('aord-entering');
      }, 350);
    }

    async function init(block) {
      block.setAttribute('data-aord-init', '1');
      const mode = block.dataset.mode || 'demo';
      const interval = parseInt(block.dataset.interval || '4000', 10);

      let pool = [];
      if (mode === 'live' && block.dataset.endpoint) {
        pool = await fetchLiveData(block.dataset.endpoint);
        if (pool.length === 0) {
          // fallback to demo if endpoint failed
          pool = pickDemoData(block);
        }
      } else {
        pool = pickDemoData(block);
      }

      if (pool.length === 0) return;

      // shuffle once for random start
      pool = pool.slice().sort(() => Math.random() - 0.5);
      let idx = 0;

      // initial render
      renderItem(block, pool[idx]);

      setInterval(() => {
        idx = (idx + 1) % pool.length;
        renderItem(block, pool[idx]);
      }, Math.max(1500, interval));

      // Re-fetch live data every 5 min to keep the pool fresh
      if (mode === 'live' && block.dataset.endpoint) {
        setInterval(async () => {
          const fresh = await fetchLiveData(block.dataset.endpoint);
          if (fresh.length > 0) pool = fresh;
        }, 300000);
      }
    }

    blocks.forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shippingtimeline"] && !Shopify.designMode) return;
  try {
    (function () {
    const blocks = document.querySelectorAll('.ashp:not([data-init])');
    if (!blocks.length) return;

    const WEEKDAYS_DE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const MONTHS_DE = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

    function addBusinessDays(date, days, skipWeekend) {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (!skipWeekend || (day !== 0 && day !== 6)) added++;
      }
      return d;
    }

    function isSameWeek(a, b) {
      const aw = new Date(a); aw.setHours(0,0,0,0);
      const bw = new Date(b); bw.setHours(0,0,0,0);
      const diff = Math.abs((aw - bw) / 86400000);
      return diff < 7 && aw.getDay() <= bw.getDay() ? true : diff < 7;
    }

    function formatDate(d, showWeekday, isThisWeek) {
      if (showWeekday && isThisWeek) {
        return WEEKDAYS_DE[d.getDay()];
      }
      return d.getDate() + '. ' + MONTHS_DE[d.getMonth()];
    }

    function updateBlock(block) {
      const processingDays = parseInt(block.dataset.processingDays || '1', 10);
      const shippingDays   = parseInt(block.dataset.shippingDays || '2', 10);
      const bufferDays     = parseInt(block.dataset.bufferDays || '0', 10);
      const cutoffHour     = parseInt(block.dataset.cutoffHour || '14', 10);
      const skipWeekend    = block.dataset.skipWeekend === 'true';
      const showWeekday    = block.dataset.showWeekday === 'true';

      const now = new Date();
      const orderBase = new Date(now);

      // Wenn Cutoff vorbei → Bearbeitung startet morgen
      if (now.getHours() >= cutoffHour) {
        orderBase.setDate(orderBase.getDate() + 1);
      }

      // Versanddatum: orderBase + processingDays
      const shipDate = addBusinessDays(orderBase, processingDays, skipWeekend);
      // Lieferung Start: shipDate + shippingDays
      const deliverStart = addBusinessDays(shipDate, shippingDays, skipWeekend);
      // Lieferung Ende: deliverStart + bufferDays
      const deliverEnd = bufferDays > 0
        ? addBusinessDays(deliverStart, bufferDays, skipWeekend)
        : deliverStart;

      const fmt = (d) => formatDate(d, showWeekday, isSameWeek(now, d));

      const step2El = block.querySelector('[data-step-2]');
      const step3El = block.querySelector('[data-step-3]');

      if (step2El) step2El.textContent = fmt(shipDate);
      if (step3El) {
        step3El.textContent = bufferDays > 0
          ? fmt(deliverStart) + ' – ' + fmt(deliverEnd)
          : fmt(deliverStart);
      }

      // Countdown bis Cutoff
      const cutoff = new Date(now);
      cutoff.setHours(cutoffHour, 0, 0, 0);
      if (now.getHours() >= cutoffHour) {
        cutoff.setDate(cutoff.getDate() + 1);
      }
      const diffMs = cutoff - now;
      const totalMin = Math.max(0, Math.floor(diffMs / 60000));
      const hours = Math.floor(totalMin / 60);
      const mins = totalMin % 60;

      const hoursEl = block.querySelector('[data-hours]');
      const minsEl = block.querySelector('[data-mins]');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(mins).padStart(2, '0');

      block.dataset.init = '1';
    }

    blocks.forEach(updateBlock);
    setInterval(() => {
      document.querySelectorAll('.ashp').forEach(updateBlock);
    }, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
